import { useDocsDataModelStore } from "@/models/docs-data/docsData";
import { StorageType } from "@/shared/constant/StorageType";

export function useStorageType() {
  const persistEnvVariables = useDocsDataModelStore((x) => x.docsBaseConfig.persistEnvVariables);
  return persistEnvVariables ? StorageType.LocalStorage : StorageType.Memory;
}
